export namespace MarketNs {

  export enum MarketRouteEnums {
    MARKET = 'Marketplace',
    MARKET_IMPORT = 'Import',
  }

  export interface ImportProjectRequest {
    workspaceId: string,
    projectId: string,
    token: string
  }
}
